import React, { forwardRef } from 'react';
import { Button, Checkbox, FormError, FormField, FormImage } from '@getro/rombo';
import { Formik, Form, Field } from 'formik';
import { ChevronRight } from 'lucide-react';
import PropTypes from 'prop-types';
import { Box, Flex, Link, Text } from 'rebass/styled-components';

export const ProfileForm = forwardRef(({ initialValues, validationSchema, onSubmit, isLoading }, ref) => (
  <Formik innerRef={ref} initialValues={initialValues} validationSchema={validationSchema} onSubmit={onSubmit}>
    {({ values, handleChange, errors }) => (
      <Form>
        <Flex flexDirection="column" sx={{ gap: '24px', '& > div:not(:last-child)': { mb: '0px' }, pb: '80px' }}>
          <Flex alignItems="center" sx={{ gap: '16px' }}>
            <Field
              filestackApiKey={import.meta.env.VITE_FILESTACK_API_KEY}
              name="avatarUrl"
              component={FormImage}
              imagePlaceholder={`${values.firstName} ${values.lastName}`}
            />
          </Flex>
          <Field type="text" name="firstName" label="First name" component={FormField} />
          <Field type="text" name="lastName" label="Last name" component={FormField} />
          <Field type="email" name="email" label="Email" component={FormField} />
          <Field autoComplete="new-password" type="password" name="password" label="Password" component={FormField} />
          <Box>
            <Checkbox
              checked={values.termsAccepted}
              onChange={handleChange}
              name="termsAccepted"
              label={
                <Text as="span">
                  I have read and I do accept the{' '}
                  <Link href="https://www.getro.com/terms" target="_blank" rel="noopener noreferrer" color="text.main">
                    terms of service
                  </Link>{' '}
                  and{' '}
                  <Link
                    href="https://www.getro.com/privacy"
                    target="_blank"
                    rel="noopener noreferrer"
                    color="text.main"
                  >
                    privacy policy
                  </Link>
                </Text>
              }
            />
            {errors?.termsAccepted && (
              <FormError mt="16px">Please accept our terms of service and privacy policy to continue.</FormError>
            )}
          </Box>
          <Button
            type="submit"
            icon={ChevronRight}
            iconPosition="right"
            sx={{ justifyContent: 'center' }}
            loading={isLoading}
          >
            Continue
          </Button>
        </Flex>
      </Form>
    )}
  </Formik>
));

ProfileForm.propTypes = {
  initialValues: PropTypes.object.isRequired,
  validationSchema: PropTypes.object.isRequired,
  onSubmit: PropTypes.func.isRequired,
  isLoading: PropTypes.bool.isRequired,
};
